import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RepairService } from '@app/repairs/services/repair.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription, firstValueFrom } from 'rxjs';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';

@Component({
    selector: 'app-repair-feedback-form',
    imports: [ CommonModule, ReactiveFormsModule, SpinnerComponent ],
    templateUrl: './repair-feedback-form.component.html',
    styleUrl: './repair-feedback-form.component.scss',
})
export class RepairFeedbackFormComponent implements OnInit, OnDestroy {

    @Input() pageSubHeading: string = ""
    @Input() successfulSubmissionText: string = ""
    @Input() failedSubmissionText: string = ""
    @Input() formText: string = ""
    @Input() repairId: string = ""
    @Input() repairJobId: string = ""
    private destroy$ = new Subject<void>();
    private userSubscription?: Subscription;

    repairJobData: any = {};
    loaded: boolean = false;
    error: boolean = false;
    appointment: any = {}
    submissionStatus: string = "New";
    formType: string = "Feedback";
    feedbackForm: FormGroup;

    form = {
        feedback: "",
        category: "General Feedback"
    };

    feedbackCategories: object = [ "General Feedback", "Comment" ]

    constructor(private repairService: RepairService,
        private adb2cService: Adb2cService,
        private ngxSpinnerService: NgxSpinnerService,
        private el: ElementRef,
        private logger: LoggerService
    ) {

        const cpt = this.el.nativeElement;

        this.pageSubHeading = cpt.getAttribute("pageSubHeading");
        this.successfulSubmissionText = cpt.getAttribute("successfulSubmissionText");
        this.failedSubmissionText = cpt.getAttribute("failedSubmissionText");
        this.formText = cpt.getAttribute("formText");
        this.repairId = cpt.getAttribute("repairId");
        this.repairJobId = cpt.getAttribute("repairJobId");

        this.feedbackForm = new FormGroup({
            feedback: new FormControl(null, [
                Validators.required,
                Validators.maxLength(2000)
            ]),
            category: new FormControl(null)
        });
        this.feedbackForm.controls[ 'category' ].setValue("General Feedback", { onlySelf: true });
    }

    ngOnInit() {

        this.adb2cService.getUser();
        this.userSubscription = this.adb2cService.activeUser.asObservable().subscribe((user: any) => {
            if (user && user.sub && user[ 'tenancy_reference' ]) {
                this.repairService.getRepairJob(this.repairId, this.repairJobId, user.sub, user[ 'tenancy_reference' ]!).subscribe({
                    next: (response) => {
                        this.repairJobData = response;
                        this.appointment.startTime = response.appointments[ 0 ].startTime;
                        this.appointment.contractorName = response.contractorName;
                        this.appointment.repairDescription = response.sors;
                        this.loaded = true;
                    },
                    error: (error) => {
                        console.error(error)
                    }
                });
            }
        });
    }

    onSubmit(e: any) {
        e.preventDefault();
        this.feedbackForm.markAllAsTouched();

        console.log(this.feedbackForm);
        if (this.feedbackForm.valid) {
            this.loaded = false;
            this.submissionStatus = "Submitted";

            firstValueFrom(this.repairService.postRepairForm(this.repairJobId, this.feedbackForm.value, this.formType)).then((response: any) => {
                console.log('applicant post success ' + response.status);
                this.submissionStatus = "Complete";
                this.loaded = true;
            })
                .catch((error) => {
                    console.log(error);
                    this.submissionStatus = "Failed";
                    this.loaded = true;
                });
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.userSubscription?.unsubscribe();
    }

    // scrollToElementById(id: string) {
    //     const targetEl = this.el.nativeElement.querySelector(`#${id}`);

    //     if (!targetEl) {
    //         return this.logger.error("no target element found for id: " + id);
    //     }

    //     const yFromTop = targetEl.getBoundingClientRect().top + window.scrollY;

    //     window.scroll({
    //         top: yFromTop,
    //         behavior: 'smooth',
    //     });
    // }

}
